import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=6f3fb2dd&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=6f3fb2dd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3fb2dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3fb2dd')) {
      api.createRecord('6f3fb2dd', component.options)
    } else {
      api.reload('6f3fb2dd', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=6f3fb2dd&scoped=true", function () {
      api.rerender('6f3fb2dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ResetPassword.vue"
export default component.exports